export class TfaRegisterRequestDto {
  constructor(
    public secret: string,
    public url: string
  ) { }
}